// 引入路由
import {createRouter, createWebHistory} from 'vue-router'
import { schoolConfigMap } from '../config/schoolConfig'

let router = createRouter({
    history: createWebHistory('/'),
    routes: [
        {
            path: '/index',
            component: () => import('../pages/Index.vue'),
            meta: {
                title: '智选志愿AI'
            }
        }, {
            path: '/home',
            component: () => import('../pages/Home.vue'),
            meta: {
                title: '智选志愿AI'
            }
        }, {
            path: '/score',
            component: () => import('../pages/Score.vue'),
            meta: {
                title: '智选志愿AI-历年分数查询'
            }
        }, {
            path: '/404',
            component: () => import('../pages/404.vue'),
            meta: { title: '页面不存在' }
        }, {
            path: '/:pathMatch(.*)*',
            component: () => import('../pages/404.vue'),
            meta: {
                title: '智选志愿AI'
            }
        }
    ]
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
    // 设置页面标题
    if (to.meta.title) {
        document.title = to.meta.title
    }

    // 白名单：如果是前往404页面本身，直接放行，避免死循环
    if (to.path === '/404') {
        return next()
    }

    // 拦截：没有school_id就跳转到404页面
    if (!to.query.school_id || !schoolConfigMap[to.query.school_id]) {
        // 使用 replace: true 替换历史记录，防止用户点击浏览器的"返回"键又跳回来
        return next({ path: '/404', replace: true })
    }

    // 如果有 school_id，正常放行
    next()
})

export default router